import React, { useEffect, useRef } from 'react';

import API from 'files/api.js';
import Appearance from 'styles/Appearance.js';
import Theme from 'styles/Theme.js';
import Utils from 'files/Utils.js';

export const Footer = ({ dealership, utils }) => {

    const getContent = () => {

        if(!dealership) {
            return null;
        }

        // determine if a mobile layout was requested 
        if(Utils.isMobile() === true) {
            return (
                <div style={{
                    alignItems: 'center',
                    backgroundColor: dealership.colors.primary || '#232323',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 24,
                    textAlign: 'center',
                    width: '100%'
                }}>
                    {typeof(dealership.bbb_url) === 'string' && (
                        <img
                        alt={`${dealership.name} BBB Business Review`}
                        className={'text-button'} 
                        onClick={window.open.bind(this, `${dealership.bbb_url}/#sealclick`)}
                        src={'images/bbb-badge.png'} 
                        style={{
                            border: 0,
                            height: 50,
                            marginBottom: 24,
                            objectFit: 'contain',
                            width: 'auto'
                        }} />
                    )}
                    <span style={{
                        color: 'white',
                        fontSize: 18,
                        fontFamily: Appearance.fonts.getFamilyForWeight(700),
                        marginBottom: 2,
                    }}>{`© 2024 ${dealership.name}`}</span>
                    <span style={{
                        color: 'white',
                        fontSize: 12,
                        fontFamily: Appearance.fonts.getFamilyForWeight(500),
                    }}>{`Version ${API.app_version} Build ${API.build}`}</span>
                    <div style={{
                        alignItems: 'center',
                        borderTop: `1px solid white`,
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: 24,
                        marginTop: 24,
                        width: '100%'
                    }}>
                        <span 
                        className={'text-button'}
                        onClick={window.open.bind(this, 'https://homesafealerts.com/dealers')}
                        style={{
                            color: 'white',
                            fontSize: 16,
                            fontFamily: Appearance.fonts.getFamilyForWeight(600),
                            marginBottom: 12,
                            textDecoration: 'underline',
                            width: 250
                        }}>{'Dealer Login'}</span>
                        <span style={{
                            color: 'white',
                            fontSize: 16,
                            fontFamily: Appearance.fonts.getFamilyForWeight(600),
                            marginBottom: 8,
                            whiteSpace: 'nowrap'
                        }}>{`Website Designed by `}
                            <span 
                            className={'text-button'}
                            onClick={window.open.bind(this, 'https://duralabs.io')}
                            style={{
                                textDecoration: 'underline'
                            }}>{`Dura Labs LLC`}</span>
                        </span>
                    </div>
                </div>
            )
        }

        return (
            <div style={{
                backgroundColor: dealership.colors.primary || '#232323',
                display: 'flex',
                flexDirection: 'column',
                padding: '2vw',
                width: '100%'
            }}>
                <div style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '100%'
                }}>
                    <div style={{
                        alignItems: 'flex-start',
                        display: 'flex',
                        flexDirection: 'column',
                        textAlign: 'left',
                        width: 250
                    }}>
                        <span style={{
                            color: 'white',
                            fontSize: 18,
                            fontFamily: Appearance.fonts.getFamilyForWeight(700),
                            marginBottom: 2,
                            whiteSpace: 'nowrap'
                        }}>{`© 2024 ${dealership.name}`}</span>
                        <span style={{
                            color: 'white',
                            fontSize: 12,
                            fontFamily: Appearance.fonts.getFamilyForWeight(500),
                            whiteSpace: 'nowrap'
                        }}>{`Version ${API.app_version} Build ${API.build}`}</span>
                        {typeof(dealership.bbb_url) === 'string' && (
                            <img
                            alt={`${dealership.name} BBB Business Review`}
                            className={'text-button'} 
                            onClick={window.open.bind(this, `${dealership.bbb_url}/#sealclick`)}
                            src={'images/bbb-badge.png'} 
                            style={{
                                border: 0,
                                height: 50,
                                marginTop: 12,
                                objectFit: 'contain',
                                width: 'auto'
                            }} />
                        )}
                    </div>
                    {typeof(dealership.disclaimer_text) === 'string' && (
                        <div style={{
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'center',
                            width: '100%'
                        }}>
                            <span style={{
                                color: 'white',
                                display: 'block',
                                fontSize: 12,
                                fontFamily: Appearance.fonts.getFamilyForWeight(500),
                                maxWidth: 1000,
                                width: '75%'
                            }}>{dealership.disclaimer_text}</span>
                        </div>
                    )}
                    <div style={{
                        alignItems: 'flex-end',
                        display: 'flex',
                        flexDirection: 'column',
                        textAlign: 'right'
                    }}>
                        <span 
                        className={'text-button'}
                        onClick={window.open.bind(this, 'https://homesafealerts.com/dealers')}
                        style={{
                            color: 'white',
                            fontSize: 16,
                            fontFamily: Appearance.fonts.getFamilyForWeight(600),
                            marginBottom: 8,
                            textDecoration: 'underline',
                            whiteSpace: 'nowrap'
                        }}>{'Dealer Login'}</span>
                        <span style={{
                            color: 'white',
                            fontSize: 16,
                            fontFamily: Appearance.fonts.getFamilyForWeight(600),
                            marginBottom: 8,
                            whiteSpace: 'nowrap'
                        }}>{`Website Designed by `}
                            <span 
                            className={'text-button'}
                            onClick={window.open.bind(this, 'https://duralabs.io')}
                            style={{
                                textDecoration: 'underline'
                            }}>{`Dura Labs LLC`}</span>
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    return getContent();
}

/*
 * NavigationSectionHeader
 *
 * The masthead every non-marketing page opens with — support, troubleshooting,
 * privacy, terms, trainee signup, certification. It used to be a full-bleed
 * slab of the dealership's primary color with 48px uppercase text, which is
 * the one thing on those pages that made them read as a different website to
 * the rest of the site.
 *
 * Rewritten in the marketing surface's language: the off-white masthead, the
 * accent eyebrow, and the same section heading used everywhere else. Six pages
 * share this component, so restyling it here restyles all of them at once
 * without touching their content.
 *
 * The waypoint id and the intersection observer are unchanged — the header
 * navigation scrolls to `navigation_component_{identifier}` and highlights the
 * matching nav item, and that has to keep working.
 */

export const NavigationSectionHeader = ({ children, dealership, eyebrow, identifier, subtitle, title, utils }) => {

    const ref = useRef(null);

    const getContent = () => {
        return dealership && (
            <div
            id={`navigation_component_${identifier}`}
            ref={ref}
            style={{
                backgroundColor: Theme.colors.offWhite,
                borderBottom: `1px solid ${Theme.colors.border()}`,
                position: 'relative',
                width: '100%'
            }}>
                <div style={{
                    margin: '0 auto',
                    maxWidth: Theme.layout.maxWidth,
                    padding: Utils.isMobile() === true ? '40px 20px' : '64px 40px',
                    textAlign: 'center'
                }}>
                    <span style={{
                        ...Theme.textStyles.label(),
                        display: 'block',
                        marginBottom: 14
                    }}>{eyebrow || dealership.name}</span>
                    <span style={{
                        ...Theme.textStyles.sectionHeading(),
                        display: 'block'
                    }}>{title}</span>
                    {subtitle && (
                        <span style={{
                            ...Theme.textStyles.sectionSubheading(),
                            display: 'block',
                            margin: '16px auto 36px'
                        }}>{subtitle}</span>
                    )}
                    {/* Slot for anything the page wants inside the masthead —
                        the support search lives here, so the first thing on the
                        page is the thing you came to do. */}
                    {children && (
                        <div style={{
                            margin: '28px auto 0',
                            width: '100%'
                        }}>{children}</div>
                    )}
                </div>
            </div>
        )
    }

    useEffect(() => {
        if(ref.current) {
            utils.navigation.setWaypointObserver(ref.current, identifier);
        }
    }, [ref.current]);

    return getContent();
}